"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultFilter = void 0;

var defaultFilter = function defaultFilter(input, childProps) {
  var toCompareText;

  if (!childProps.hint && typeof childProps.children === 'string') {
    toCompareText = childProps.children;
  } else {
    toCompareText = childProps.hint || childProps.text || '';
  }

  return toCompareText.toLowerCase().replace(/\s/g, '').indexOf(input.toLowerCase().replace(/\s/g, '')) >= 0;
};

exports.defaultFilter = defaultFilter;